import React, { CSSProperties } from 'react';
import { DialogContent, DialogOverlay, DialogWrapper } from './CustomDialogWrapper.Styled';

interface CustomDialogWrapperProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  width: string;
  height?: string;
  wrapperStyle?: CSSProperties;
  overlayStyle?: CSSProperties;
  contentStyle?: CSSProperties;
  showSecondWrapper?: boolean;
  secondWrapperWidth?: string;
  secondWrapperStyle?: CSSProperties;
  SecondComponent?: React.FC;
}

const CustomDialogWrapper: React.FC<CustomDialogWrapperProps> = ({
  open,
  onClose,
  children,
  width,
  height = '550px',
  wrapperStyle = {},
  overlayStyle = {},
  contentStyle = {},
  showSecondWrapper = false,
  secondWrapperWidth = '300px',
  secondWrapperStyle = {},
  SecondComponent,
}) => {
  if (!open) return null;

  return (
    <DialogOverlay onClick={onClose} style={overlayStyle}>
      <DialogWrapper width={width} style={{ height: height, ...wrapperStyle }} onClick={(e) => e.stopPropagation()}>
        <DialogContent style={{ display: 'flex', flexDirection: 'column', height: '100%', ...contentStyle }}>
          {children}
        </DialogContent>
      </DialogWrapper>

      {showSecondWrapper && SecondComponent && (
        <DialogWrapper
          width={secondWrapperWidth}
          style={{ height: height, ...secondWrapperStyle }}
          onClick={(e) => e.stopPropagation()}
        >
          <SecondComponent />
        </DialogWrapper>
      )}
    </DialogOverlay>
  );
};

export default CustomDialogWrapper;
